<section class="checklist-execution-map-container" *ngIf="!isLoadingCheckListMap && !isLoadingLabels && !isLoadingAvailableFilters">
	<header>
		<h1>{{ labels.lbl_calendario_checklists }}</h1>

		<div class="under-title">
			<nav class="navigation">
				<a [routerLink]="'/checklist'">< {{ labels['lbl_checklist'] }}</a>
				<a [routerLink]="'/checklist/map'">< {{ labels['lbl_calendario_checklists'] }}</a>
			</nav>
		</div>
	</header>
	<main>
		<div class="calendar-filter">
			<span>{{ labels.lbl_geral_ano }}:</span>
			<select (change)="selectedDate.setYear($event.target.value)">
				<option *ngFor="let year of availableYears" [value]="year" [selected]="selectedDate.year == year">{{ year }}</option>
			</select>
			<span>{{ labels.lbl_geral_mes }}:</span>
			<select (change)="selectedDate.setMonth($event.target.value)">
				<option *ngFor="let month of availableMonths" [value]="month.value" [selected]="selectedDate.month == month.value">
					{{ labels[month.label] }}
				</option>
			</select>
			<div class="button-container">
				<button (click)="getChecklistMap()"><fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon></button>
			</div>
		</div>
		<div class="legend">
			<span>{{ labels.lbl_geral_legenda }}: </span>
			<span class="success">{{ labels.lbl_geral_executado_sucesso }}</span>
			<span class="warning">{{ labels.lbl_chamado_tarefa_em_execucao }}</span>
			<span class="danger">{{ labels.lbl_geral_falhou }}</span>
			<span class="empty">{{ labels.lbl_projetos_nao_iniciado }}</span>
		</div>
		<div [ngStyle]="{ 'grid-template-columns': 'repeat(' + (Object.keys(checklistMap).length + 2) + ', 1fr)' }" class="map-grid">
			<div>{{ labels.lbl_hora_dia }}</div>
			<div *ngFor="let checklistDay of Object.keys(checklistMap); let index = index">{{ checklistDay }}</div>
			<div>{{ labels.lbl_rep_total_das_horas }}</div>
			<ng-container *ngFor="let checklistHour of Object.keys(checklistMap['1'])">
				<div>{{ checklistHour }}</div>
				<div *ngFor="let checklistDay of Object.keys(checklistMap)">
					<a
						[routerLink]="'/checklist/edit/' + checklist.id"
						class="checklist"
						[ngClass]="{
							success: checklist.status === 'COMPLETE',
							warning: checklist.status === 'RUNNING',
							danger: checklist.status === 'FAIL',
						}"
						*ngFor="let checklist of checklistMap[checklistDay][checklistHour].checklists; let index = index">
						{{ checklist.id }}
					</a>
				</div>
				<div>{{ sumTotalHoursThroughDays(checklistHour) }}</div>
			</ng-container>
			<div>{{ labels.lbl_rep_total_dos_dias }}</div>
			<div *ngFor="let checklistDay of Object.keys(checklistMap); let index = index">{{ sumTotalChecklistsInDay(checklistDay) }}</div>
			<div>{{ sumTotalChecklistInMonth() }}</div>
		</div>
	</main>
</section>

<div class="loading-container" *ngIf="isLoadingLabels || isLoadingCheckListMap || isLoadingAvailableFilters">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
